import { createRoute, useSearch } from "@tanstack/solid-router";
import { useNavigate } from "@/lib/u-router";
import { adminRoute } from "./admin";
import { EmailCampaignManager } from "@/features/admin/components/email-campaign-manager";
import { PageContainer } from "@/components/ui/page-container";

interface AdminEmailCampaignsSearch {
  /** Abre el formulario "nueva campaña" (`?new=1`). */
  new?: boolean;
}

function AdminEmailCampaignsPage() {
  const search = useSearch({ from: "/u/$u/admin/email/campaigns" });
  const navigate = useNavigate();

  // El formulario "nueva campaña" es deep-linkable (`?new=1`): la URL es la
  // fuente de verdad para abrir/cerrar.
  const setCreating = (open: boolean): void => {
    if (open === Boolean(search().new)) {
      return;
    }
    void navigate({
      to: "/admin/email/campaigns",
      search: open ? { new: true } : {},
      replace: true,
    });
  };

  return (
    <PageContainer maxWidth="6xl">
      <EmailCampaignManager creating={Boolean(search().new)} onCreatingChange={setCreating} />
    </PageContainer>
  );
}

export const adminEmailCampaignsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email/campaigns",
  validateSearch: (search: Record<string, unknown>): AdminEmailCampaignsSearch => ({
    // Incluye el NÚMERO 1: TanStack auto-parsea `?new=1` a number 1 (no string);
    // sin este caso el param se descartaba en el boot y el diálogo no abría por
    // deep-link (CC-18).
    new:
      search.new === true || search.new === 1 || search.new === "1" || search.new === "true"
        ? true
        : undefined,
  }),
  component: AdminEmailCampaignsPage,
});
